import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AssistantState, PendingPrompt } from "./definitions";

const initialState: AssistantState = {
  isOpen: false,
  pendingPrompt: null,
};

export const assistantSlice = createSlice({
  name: "assistant",
  initialState,
  reducers: {
    setAssistantOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setPendingPrompt: (state, action: PayloadAction<PendingPrompt | null>) => {
      state.pendingPrompt = action.payload;
    },
  },
});

export const { setAssistantOpen, setPendingPrompt } = assistantSlice.actions;

export default assistantSlice.reducer;
